import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import SearchBar from "../../components/SearchBar";
import { requireUserLogin } from "../../routes/Auth/HOCs";
import {
  getSavedSearch,
  selectSavedSearch,
  deleteSavedSearch,
  updateSavedSearch,
  selectIsLoadingSavedSearches,
  startLoadingSavedSearches
} from "../../routes/Search/search.ducks";
import { useDispatch } from "react-redux";
import { selectCategories, selectModules } from "../App/selectors";
import LeftMenu from "../../components/LeftMenu";
import { AllTypeCategory } from "../../models";
import { checkEmptyObject } from "../../services";

import ListSavedSearch from "./ListSavedSearch";
import EmptyText from "./EmptyText";
import HelmetComponent from "../../utils/HelmetHelper";
import { categoriesInterface, UserI } from "../../typings/interfaces";
import { ModulesI } from "../../typings/routesTypes";

import SavedSearchPageLoader from "./SavedSearchPageLoader";

interface SavedSearchPageProps {
  categories: categoriesInterface[];
  deleteSavedSearch: (id: string, savedSearches: savedSearchesI, onComplete?: Function) => void;
  getSavedSearch: (
    categories?: categoriesInterface[],
    modules?: ModulesI[],
    module?: string,
    page?: number
  ) => void;
  history: History;
  location: Location;
  match: { path: string; url: string; isExact: boolean; params: {} };
  modules: ModulesI[];
  savedSearches: savedSearchesI;
  staticContext: any;
  updateSavedSearch: (
    id: string,
    data: any,
    savedSearches: savedSearchesI
  ) => void;
  user: UserI;
  isLoadingSavedSearches: boolean;
}

interface savedSearchesI {
  count: number;
  data: {
    category: string;
    createdTime: string;
    criteria: any;
    formattedCreatedTime: string;
    id: string;
    imageId: string;
    module: string;
    name: string;
    notifyFrequency: number;
    text: string | null;
  }[];
  page: number;
}

const SavedSearchPage = (props: SavedSearchPageProps) => {
  const {
    savedSearches,
    match: { path },
    modules,
    categories,
    isLoadingSavedSearches
  } = props;

  const dispatch = useDispatch();
  const [selectedModule, setSelectedModule] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    props.getSavedSearch(categories, modules);
  }, [JSON.stringify(categories)]);

  // Handle pagination when current page becomes empty after deletion
  useEffect(() => {
    if (savedSearches && savedSearches.page > 1 && savedSearches.data && savedSearches.data.length === 0) {
      setCurrentPage(savedSearches.page - 1);
      getData(selectedModule, savedSearches.page - 1);
    }
  }, [JSON.stringify(savedSearches)]);

  const getData = (module?, page?) => {
    const { categories } = props;

    if (categories && categories.length > 0) {
      props.getSavedSearch(
        categories,
        modules,
        module === AllTypeCategory.name ? undefined : module,
        page
      );
    }
  };

  const handleDeleteClick = id => {
    // Calculate if we need to go to previous page after deletion
    const isLastItemOnPage = savedSearches && savedSearches.data && savedSearches.data.length === 1 && currentPage > 1;
    const nextPage = isLastItemOnPage ? currentPage - 1 : currentPage;

    // Delete and reload the list after deletion (similar to favorites behavior)
    props.deleteSavedSearch(id, savedSearches, () => {
      if (isLastItemOnPage) {
        setCurrentPage(nextPage);
      }
      getData(selectedModule, nextPage);
    });
  };

  const handleNotificationClick = data => {
    props.updateSavedSearch(data.id, data, props.savedSearches);
  };

  const handleModuleSearch = (value: any) => {
    const updatedValue = value === AllTypeCategory.name ? undefined : value;

    setSelectedModule(updatedValue);
    handleSubmit(updatedValue);
  };

  const handlePageChange = nextPage => {
    setCurrentPage(nextPage);
    getData(selectedModule, nextPage);
    window.scrollTo(0, 0);
  };

  const handleNotificationChange = (item, value) => {
    const savedSearch = { ...item, notifyFrequency: value };
    handleNotificationClick(savedSearch);
  };

  const handleSubmit = value => {
    getData(value);
  };



  const searchBarActions = {
    // @ts-ignore
    onModuleSearch: (...params) => handleModuleSearch(...params)
  };

  return (
    <LeftMenu activeKey={path}>
      <HelmetComponent
        title={`${"Moje pretrage"} | ${"INDEX OGLASI"}`}
        ogTitle="Pogledajte spremljene oglase"
        index={false}
      />

      <p className="page-title">{"Moje pretrage"}</p>
      <SearchBar
        module={selectedModule}
        modules={modules}
        adCount={savedSearches && savedSearches.count ? savedSearches.count : 0}
        {...searchBarActions}
      />
      {isLoadingSavedSearches ? (
        <SavedSearchPageLoader />
      ) : checkEmptyObject(savedSearches) ? (
        savedSearches.count > 0 ? (
          <ListSavedSearch
            savedSearches={savedSearches}
            onDelete={handleDeleteClick}
            onNotificationChange={handleNotificationChange}
            onPageChange={handlePageChange}
          />
        ) : (
          <EmptyText />
        )
      ) : (
        <SavedSearchPageLoader />
      )}
    </LeftMenu>
  );
};

SavedSearchPage.defaultProps = {
  savedSearches: {}
};

const ConnectedSavedSearchPage = connect(
  state => ({
    categories: selectCategories(state),
    savedSearches: selectSavedSearch(state),
    modules: selectModules(state),
    isLoadingSavedSearches: selectIsLoadingSavedSearches(state)
  }),
  {
    getSavedSearch,
    deleteSavedSearch,
    updateSavedSearch
  }
  // @ts-ignore
)(SavedSearchPage);

export default requireUserLogin(ConnectedSavedSearchPage);



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/index.tsx